// ============================================================
// VCS.DatingGeo — Position ermitteln und auf eine Zelle runden
// ============================================================
// Pendant zu geo_cell_service.dart.
//
// DIE UNGERUNDETE POSITION VERLAESST DAS GERAET NIE. Nur das Ergebnis von
// currentCell() geht an den Server; es gibt dort keine Spalte fuer lat/lon, und
// diese Klasse gibt bewusst keine Koordinaten nach aussen.
//
// WIE GROB GERUNDET WIRD, ENTSCHEIDET DER NUTZER (Profil: cellPrecision) --
// ~750 x 610 m oder ~38 x 19 m. Bis zum 16.07. war das hier festverdrahtet.
//
// Ebenfalls bis zum 16.07. stand hier "niedrige Genauigkeit ist ein Feature,
// kein Kompromiss". Das verwechselte zwei Dinge: Das RUNDEN schuetzt die
// Privatsphaere, die MESSUNG muss trotzdem genau sein. Wer die richtige Zelle
// treffen will, muss genauer messen als das Raster breit ist -- sonst wuerfelt
// die Zelle. In der App lagen so zwei Handys im selben Raum in Zellen 1,5 km
// auseinander und sahen sich nie. Hohe Genauigkeit ist deshalb kein Widerspruch
// zum Runden, sondern seine Voraussetzung.
//
// Warum Runden statt Zufalls-Rauschen: Rauschen mittelt sich ueber mehrere
// Messungen weg und ist damit wertlos. Ein festes Raster nicht -- dieselbe
// Position ergibt immer dieselbe Zelle. Siehe dating_plan.md.
// ============================================================
window.VCS = window.VCS || {};

VCS.DatingGeo = class {

    // ── Konstanten ───────────────────────────────────────────

    // Voreinstellung, wenn niemand etwas anderes sagt: das Ungefaehre. Die Wahl
    // trifft der Nutzer im Profil (VCS.DatingCore.PRECISIONS).
    static CELL_PRECISION = 6;

    static BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';

    // Ein getLastKnownPosition wie bei geolocator gibt es im Browser nicht.
    // Aequivalent ist maximumAge -- aber nicht mit zehn Minuten: In zehn Minuten
    // faehrt man Kilometer, und eine alte Position trifft ein 750-m-Raster nie
    // zuverlaessig. Zwei Minuten sind der Kompromiss aus "kommt sofort" und
    // "stimmt noch".
    // enableHighAccuracy: true -- siehe Kopf der Datei. Der Timeout verhindert,
    // dass der Ladebalken ewig steht: Drinnen kann ein GPS-Fix lange dauern oder
    // nie kommen.
    static GEO_OPTIONS = {
        enableHighAccuracy: true,
        maximumAge        : 120000,
        timeout           : 10000
    };

    constructor() {}

    init() {}

    // ── Zelle ────────────────────────────────────────────────

    // Aktuelle Zelle, oder '' wenn keine Freigabe / kein Fix. Wirft nie.
    //
    // precision ist die Wahl des Nutzers aus seinem Profil. Gerundet wird HIER,
    // auf dem Geraet: Was diese Methode zurueckgibt, ist alles, was je nach
    // draussen geht.
    async currentCell(precision = VCS.DatingGeo.CELL_PRECISION) {
        if (!navigator.geolocation) {
            console.warn('[dating-geo] Browser kann keine Ortung');
            return '';
        }
        const prec = VCS.DatingCore.PRECISIONS.includes(precision)
            ? precision : VCS.DatingGeo.CELL_PRECISION;
        try {
            const pos = await this._getPosition();
            const cell = VCS.DatingGeo.encode(
                pos.coords.latitude, pos.coords.longitude, prec);
            // Zelle und Messgenauigkeit loggen ist unkritisch und sagt bei
            // Fehlersuche genau das, was man wissen will: Liegt die Messung
            // ueber der Zellbreite, ist die Zelle Glueckssache. Die Koordinaten
            // tauchen hier nirgends auf.
            console.log('[dating-geo] Zelle ermittelt: ' + cell + ' (p' + prec
                + ', Messgenauigkeit ~' + Math.round(pos.coords.accuracy || 0) + ' m)');
            return cell;
        } catch (e) {
            // code 1 = PERMISSION_DENIED, 2 = POSITION_UNAVAILABLE, 3 = TIMEOUT
            console.warn('[dating-geo] keine Position: code=' + (e && e.code)
                + ' msg=' + (e && e.message ? e.message : 'unbekannt'));
            return '';
        }
    }

    _getPosition() {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, VCS.DatingGeo.GEO_OPTIONS);
        });
    }

    // ── Bewegung verfolgen ───────────────────────────────────

    // Meldet NUR Zellwechsel, nicht jede Messung. Der Browser kennt keinen
    // distanceFilter wie geolocator — der Zellen-Vergleich IST der Filter: Wer
    // stillsteht (oder sich innerhalb seiner Zelle bewegt), loest nichts aus.
    // Das ist genau die Sparsamkeit, die der Socket bringen soll.
    //
    // onCell(cell) bekommt die neue Zelle. Rueckgabe ist die watch-ID fuer
    // stopWatch(), 0 wenn nichts geht.
    //
    // knownCell ist die Zelle, die der Aufrufer schon kennt und gemeldet hat.
    // Ohne sie meldet der allererste Callback einen "Wechsel" auf genau die
    // Zelle, die gerade eben mit radar-enter rausging — ein Zellwechsel, der
    // keiner ist.
    startWatch(precision, onCell, knownCell = '') {
        if (!navigator.geolocation) {
            console.warn('[dating-geo] Browser kann keine Ortung');
            return 0;
        }
        const prec = VCS.DatingCore.PRECISIONS.includes(precision)
            ? precision : VCS.DatingGeo.CELL_PRECISION;
        let lastCell = knownCell || '';

        const id = navigator.geolocation.watchPosition(
            (pos) => {
                const cell = VCS.DatingGeo.encode(
                    pos.coords.latitude, pos.coords.longitude, prec);
                if (!cell || cell === lastCell) {
                    return;
                }
                lastCell = cell;
                console.log('[dating-geo] Zellwechsel: ' + cell + ' (p' + prec
                    + ', Messgenauigkeit ~' + Math.round(pos.coords.accuracy || 0) + ' m)');
                onCell(cell);
            },
            (e) => {
                // Nicht abbrechen: watchPosition liefert zwischendurch Fehler
                // (kein Fix im Tunnel) und danach wieder Positionen.
                console.warn('[dating-geo] watch: code=' + (e && e.code)
                    + ' msg=' + (e && e.message ? e.message : 'unbekannt'));
            },
            VCS.DatingGeo.GEO_OPTIONS
        );
        console.log('[dating-geo] watchPosition gestartet (id=' + id + ')');
        return id;
    }

    // Ortung stoppen. Ohne das laeuft GPS weiter, wenn niemand hinsieht.
    stopWatch(id) {
        if (id && navigator.geolocation) {
            navigator.geolocation.clearWatch(id);
            console.log('[dating-geo] watchPosition gestoppt (id=' + id + ')');
        }
    }

    // Zelle ermitteln und am Server setzen. Gibt die Zelle zurueck ('' wenn
    // nichts ging): Der Aufrufer braucht sie als Bezugspunkt fuers Radar --
    // ohne die eigene Zelle gibt es kein "da drueben".
    // Bei verweigerter Ortung wird nichts gesetzt -- was nicht kommt, soll auch
    // nichts ueberschreiben.
    async syncCell(precision = VCS.DatingGeo.CELL_PRECISION) {
        const cell = await this.currentCell(precision);
        if (!cell) {
            return '';
        }
        const ok = await VCS.datingCore.setCell(cell);
        return ok ? cell : '';
    }

    // ── Geohash ──────────────────────────────────────────────

    // Gegenstueck zu encode(): Mittelpunkt und Groesse einer Zelle.
    // { lat, lon, latHeight, lonWidth } -- alles in Grad.
    //
    // Braucht das Radar, um aus zwei Zellen Richtung und Entfernung zu rechnen.
    // Die Groesse kommt mit, weil sie von der Praezision abhaengt (P6 ~ 0,011
    // Grad breit, P8 ~ 0,00034) -- und weil ein Punkt exakt im Zellzentrum eine
    // Genauigkeit behaupten wuerde, die es nicht gibt: Innerhalb der Zelle ist
    // jede Position gleich wahrscheinlich.
    static decode(hash) {
        let evenBit = true;
        let latMin = -90.0, latMax = 90.0;
        let lonMin = -180.0, lonMax = 180.0;

        for (const c of String(hash || '')) {
            const idx = VCS.DatingGeo.BASE32.indexOf(c);
            if (idx < 0) {
                break;   // Unbekanntes Zeichen: lieber groeber als falsch.
            }
            for (let b = 4; b >= 0; b--) {
                const bit = (idx >> b) & 1;
                if (evenBit) {
                    const lonMid = (lonMin + lonMax) / 2;
                    if (bit === 1) { lonMin = lonMid; } else { lonMax = lonMid; }
                } else {
                    const latMid = (latMin + latMax) / 2;
                    if (bit === 1) { latMin = latMid; } else { latMax = latMid; }
                }
                evenBit = !evenBit;
            }
        }

        return {
            lat      : (latMin + latMax) / 2,
            lon      : (lonMin + lonMax) / 2,
            latHeight: latMax - latMin,
            lonWidth : lonMax - lonMin
        };
    }

    // Reine Mathematik, 1:1 aus geo_cell_service.dart. Statisch, damit sie ohne
    // Instanz pruefbar ist -- der Rest der App braucht sie nicht.
    static encode(lat, lon, precision) {
        let idx = 0;
        let bit = 0;
        let evenBit = true;
        let hash = '';

        let latMin = -90.0, latMax = 90.0;
        let lonMin = -180.0, lonMax = 180.0;

        while (hash.length < precision) {
            if (evenBit) {
                const lonMid = (lonMin + lonMax) / 2;
                if (lon >= lonMid) {
                    idx = idx * 2 + 1;
                    lonMin = lonMid;
                } else {
                    idx = idx * 2;
                    lonMax = lonMid;
                }
            } else {
                const latMid = (latMin + latMax) / 2;
                if (lat >= latMid) {
                    idx = idx * 2 + 1;
                    latMin = latMid;
                } else {
                    idx = idx * 2;
                    latMax = latMid;
                }
            }
            evenBit = !evenBit;
            if (++bit === 5) {
                hash += VCS.DatingGeo.BASE32[idx];
                bit = 0;
                idx = 0;
            }
        }
        return hash;
    }
};
